import { extend } from 'flarum/common/extend';
import classList from 'flarum/common/utils/classList';
import { tagAnimation, tagBackgroundUrl, tagIcon, tagStyleVars } from '../common/tagImages';
import { animationFor, animationHostClass, iconFor } from '../common/pixelArt';

/**
 * Pixel styling for FoF Categories (fof/categories). Only runs when that
 * extension is enabled: the registry calls the handler once its Category
 * component is registered.
 *
 * FoF paints each parent row in the tag colour with fixed white text, which
 * is unreadable on light colours. Instead, the tag colour goes into custom
 * properties (accent bar, icon tile) and the theme's LESS draws the rows.
 */
export default function extendCategories() {
  flarum.reg.onLoad('fof-categories', 'forum/components/Category', Category => {
    extend(Category.prototype, 'view', function (vdom) {
      if (!vdom || !vdom.attrs || !this.tag) return;
      vdom.attrs.className = classList(vdom.attrs.className, 'PxCategory', {
        'PxCategory--hasBackground': tagBackgroundUrl(this.tag)
      });
      vdom.attrs.style = {
        ...(vdom.attrs.style || {}),
        ...tagStyleVars(this.tag)
      };
    });

    // Drop FoF's inline background colour on the row, and mark rows that
    // host an animation.
    extend(Category.prototype, 'categoryItems', function (items) {
      if (!items.has('link')) return;
      const link = items.get('link');
      if (!link || !link.attrs) return;
      link.attrs.style = {};
      link.attrs.className = classList(link.attrs.className, animationHostClass(tagAnimation(this.tag)));
    });

    // Animated background, behind the row's content.
    extend(Category.prototype, 'contentItems', function (items) {
      const animation = animationFor(tagAnimation(this.tag));
      if (animation) items.add('pxAnimation', animation, 1000);
    });

    // A PixMMO sprite, hero, monster or image replaces the Font Awesome icon.
    extend(Category.prototype, 'iconItems', function (items) {
      const art = iconFor(tagIcon(this.tag));
      if (!art) return;
      const icon = m("span", {
        className: "PxCategory-iconTile"
      }, art);
      if (items.has('icon')) items.setContent('icon', icon);else items.add('icon', icon, 10);
    });
  });
}